import ApiRequest from './ApiRequest';

export default {
    get(key, cb, isClass = null, domain = null, country = null) {
        let generalKey = `${key}`;
        generalKey += isClass ? '/true' : '/false';
        if (domain) {
            generalKey += `/${domain}`;
            if (country) {
                generalKey += `/${country}`;
            }
        }

        let localKey = `language/${generalKey}_${window.languageVersion}`;

        let ignoreCacheFrom = 1584633000000; // timestamp in milliseconds for 2020-03-19 15:50 a day after the last language reset

        let item = localStorage ? localStorage.getItem(localKey) : null;
        let parsedItem = JSON.parse(item);

        if (item && parsedItem && (parsedItem.expires_at * 1000) > Date.now() && (parsedItem.expires_at * 1000) > ignoreCacheFrom) {
            cb(JSON.parse(item), false);
        } else {
            let request = new ApiRequest();
            request.get(`language/${generalKey}?key=${window.languageVersion}`, {}, (err, res) => {
                if (res && res.body && res.body.data && res.body.success) {
                    if (localStorage) {
                        try {
                            localStorage.setItem(localKey, JSON.stringify(res.body.data));
                        } catch (e) {
                            Bugsnag.notify('Anyone - SiteLanguage@get:', 'Config localStorage error', { e });
                        }
                    }
                    cb(res.body.data, false);
                } else {
                    Bugsnag.notify('Anyone - SiteLanguage@get:', 'No language for the required key', { key: generalKey });
                    cb({}, true);
                }
            });
        }
    },
    executeReplacements(string = '', replacements = {}) {
        for (let key in replacements) {
            string = string.replace(`:${key}`, replacements[key]);
        }
        return string;
    }
};